const verseBtcStakingV3Data = {
  contractAddress: '0x34a0D5C9C096326d6C66ebAFe72e34c9C453C512',
  stakingToken: {
    token: '0x34a0D5C9C096326d6C66ebAFe72e34c9C453C512',
    decimals: 18,
    abbr: 'vstBTC3',
    value: 'vstBTC3',
    blockchain: 'ETH',
    label: 'VERSE stBTC Receipts',
    ticker: 'vstbtc3',
    explorer: '',
    protocol: 'ERC_20_PROTOCOL',
    icon: 'https://markets.bitcoin.com/images/coins/verse.png',
  },
  zapToken: {
    token: '0x249cA82617eC3DfB2589c4c17ab7EC9765350a18',
    decimals: 18,
    abbr: 'VERSE',
    value: 'VERSE',
    blockchain: 'ETH',
    label: 'Verse',
    ticker: 'verse',
    explorer: 'https://etherscan.io/tx/',
    protocol: 'ERC_20_PROTOCOL',
    icon: 'https://markets.bitcoin.com/images/coins/verse.png',
  },
  rewardToken: {
    token: '0x18084fba666a33d37592fa2633fd49a74dd93a88',
    decimals: 18,
    abbr: 'tBTC',
    value: 'tBTC',
    blockchain: 'ETH',
    label: 'tBTC v2',
    ticker: 'tbtc',
    explorer: 'https://etherscan.io/tx/',
    protocol: 'ERC_20_PROTOCOL',
    icon: 'https://markets.bitcoin.com/images/coins/26133.png',
  },
  rewardTokens: [
    {
      token: '0x18084fba666a33d37592fa2633fd49a74dd93a88',
      decimals: 18,
      abbr: 'tBTC',
      value: 'tBTC',
      blockchain: 'ETH',
      label: 'tBTC v2',
      ticker: 'tbtc',
      explorer: 'https://etherscan.io/tx/',
      protocol: 'ERC_20_PROTOCOL',
      icon: 'https://markets.bitcoin.com/images/coins/26133.png',
    },
  ],
  pair: {
    id: '0x249cA82617eC3DfB2589c4c17ab7EC9765350a18',
    name: 'VERSE',
    token0: {
      name: 'Verse',
      symbol: 'VERSE',
      id: '0x249cA82617eC3DfB2589c4c17ab7EC9765350a18',
      decimals: 18,
    },
  },
  singleSided: true,
  customPath: 'verse-btc',
  dynamicRewards: false,
};

export default verseBtcStakingV3Data;
